define('BackInStock.View', [
    'Backbone',
    'BackInStockNotification.Views.Subscribe',
    'backinstock_view.tpl'
], function BackboneView(
    Backbone,
    SubscribeView,
    backinstockViewTpl
) {
    'use strict';

    return Backbone.View.extend({
        template: backinstockViewTpl,

        initialize: function initialize(options) {
            var self = this;
            this.pdp = options.pdp;
            this.application = options.application;
            this.pdp = options.pdp;

            this.pdp.on('afterOptionSelection', function afterOptionSelection() {
                self.render();
            });
        },

        childViews: {
            'BackInStock.Subscribe.View': function backInStockSubscribeView() {
                return new SubscribeView({
                    application: this.application,
                    pdp: this.pdp
                });
            }
        },

        getContext: function getContext() {
            var getStockInfo = this.pdp.getStockInfo();
            return {
                showOutOfStockMessage: getStockInfo.showOutOfStockMessage
            };
        }
    });
});
